import { View, Text } from "@react-pdf/renderer";

type TextWrapperProps = {
  text?: string;
  style?: any;
  containerStyle?: any;
};

export default function TextWrapperWithLineBreaks({
  text,
  style,
  containerStyle,
}: TextWrapperProps) {
  if (!text) return null;

  const lines = text.trim().split("\n");

  return (
    <View
      style={{
        flexDirection: "column",
        ...containerStyle,
      }}
    >
      {lines.map((line, lineIndex) => (
        <Text key={lineIndex} style={style}>
          {line}
        </Text>
      ))}
    </View>
  );
}
